import type { PropsWithChildren } from 'react';
import { SWRConfig } from 'swr';
import fetcher from './fetcher';

const SWRConfigProvider: React.FC<PropsWithChildren<{}>> = ({ children }) => {
  return (
    <SWRConfig
      value={{
        errorRetryCount: 5,
        revalidateOnFocus: true,
        fetcher,
      }}
    >
      {children}
    </SWRConfig>
  );
};

export default SWRConfigProvider;
